import { FrontendEnvironment as e, BackendEnvironment as l } from "../../_types/misc/environments.mjs";
const s = "-dev.autohaus-digital.de", o = "-next.autohaus-digital.de", h = "-pre-release.autohaus-digital.de", r = "-test.autohaus-digital.de", i = "-live.autohaus-digital.de", n = (t, a) => t === e.LOCALSERVER ? `http://localhost:${a}` : `https://fleet${t === e.DEV ? "-dev" : t === e.NEXT ? "-next" : t === e["PRE-PRELEASE"] ? "-pre-release" : t === e.TEST ? "-test" : ""}.autohaus-digital.de`, E = (t, a) => t === l.LOCALSERVER ? `http://localhost:${a}` : `https://cars-ts${t === l.DEV ? "-dev" : t === l.NEXT ? "-next" : ""}.autohaus-digital.de`;
export {
  E as ahdFleetBackendUrl,
  s as ahdFleetDevUrl,
  n as ahdFleetFrontendUrl,
  i as ahdFleetLiveUrl,
  o as ahdFleetNextUrl,
  h as ahdFleetPreReleaseUrl,
  r as ahdFleetTestUrl
};
